import { render, staticRenderFns } from "./OtherServicesComponent.vue?vue&type=template&id=5a434418&scoped=true"
import script from "./OtherServicesComponent.vue?vue&type=script&lang=js"
export * from "./OtherServicesComponent.vue?vue&type=script&lang=js"
import style0 from "./OtherServicesComponent.vue?vue&type=style&index=0&id=5a434418&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a434418",
  null
  
)

export default component.exports